"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectSendButton = exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Localize = require("../Localization/Localize");

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

var _IconButton = _interopRequireDefault(require("./IconButton"));

var _SendIcon = _interopRequireDefault(require("./Assets/SendIcon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var connectSendButton = function connectSendButton() {
  for (var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++) {
    selectors[_key] = arguments[_key];
  }

  return _connectToWebChat.default.apply(void 0, [function (_ref) {
    var disabled = _ref.disabled,
        language = _ref.language,
        sendBoxValue = _ref.sendBoxValue,
        setSendBox = _ref.setSendBox,
        submitSendBox = _ref.submitSendBox;
    return {
      click: function click() {
        setSendBox(sendBoxValue.trim());
        submitSendBox();
      },
      disabled: disabled,
      language: language
    };
  }].concat(selectors));
};

exports.connectSendButton = connectSendButton;

var SendButton = function SendButton(_ref2) {
  var click = _ref2.click,
      disabled = _ref2.disabled,
      language = _ref2.language;
  return _react.default.createElement(_IconButton.default, {
    alt: (0, _Localize.localize)('Send', language),
    disabled: disabled,
    onClick: click
  }, _react.default.createElement(_SendIcon.default, null));
};

SendButton.defaultProps = {
  disabled: false
};
SendButton.propTypes = {
  click: _propTypes.default.func.isRequired,
  disabled: _propTypes.default.bool,
  language: _propTypes.default.string.isRequired
};

var _default = connectSendButton()(SendButton);

exports.default = _default;